import { createFileRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';

import { PageSkeleton } from '~/components/common/page-skeleton/page-skeleton';

const ProductPickerPage = lazy(() => import('~/features/onboarding/pages/product-picker-page'));

export const Route = createFileRoute('/_authenticated/_tenant/onboarding/')({
  component: () => (
    <Suspense fallback={<PageSkeleton />}>
      <ProductPickerPage />
    </Suspense>
  ),
});
